var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-about-contacts-item"},[_c('a',{staticClass:"plugin-about-contacts-item__link",attrs:{"href":_vm.url},domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }